import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { CallApi, chain } from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/SendWishListPdf";
import { customSendPdf } from "@thos/Services/CustomWishListService";


export type HandlerType = Parameters<typeof CallApi>[0];

async function ThosSendWishListPdf(props: HandlerType) {
    props.apiResult = await customSendPdf(props.apiParameter);
}
replaceInChain(chain, CallApi, ThosSendWishListPdf);